import { forwardRef } from 'react';
import { Loader2 } from 'lucide-react';

const VARIANTS = {
  primary:   'bg-brand-700 text-white hover:bg-brand-800 active:bg-brand-900 disabled:bg-brand-700/50',
  secondary: 'bg-white text-slate-900 border border-slate-200 hover:bg-slate-50 active:bg-slate-100 disabled:opacity-50',
  ghost:     'bg-transparent text-slate-700 hover:bg-slate-100 active:bg-slate-200 disabled:opacity-50',
  danger:    'bg-status-red text-white hover:bg-red-700 active:bg-red-800 disabled:bg-status-red/50',
  // Dominio "hidratación": mismo tono sky-700 que el ícono Droplets en
  // HydrationCard / WaterGroupForm. Identidad visual del dominio agua.
  water:     'bg-sky-700 text-white hover:bg-sky-800 active:bg-sky-900 disabled:bg-sky-700/50',
};

const SIZES = {
  sm: 'h-9 px-3 text-sm',
  md: 'h-11 px-4 text-base',
  lg: 'h-14 px-6 text-base font-medium',
};

const Button = forwardRef(
  (
    {
      as: Component = 'button',
      variant = 'primary',
      size = 'md',
      isLoading = false,
      leftIcon: LeftIcon,
      rightIcon: RightIcon,
      fullWidth = false,
      className = '',
      children,
      disabled,
      type,
      ...rest
    },
    ref
  ) => {
    const isDisabled = disabled || isLoading;

    // type solo aplica a <button>. Si el componente es otro (ej: Link), lo evitamos.
    const buttonProps =
      Component === 'button' ? { type: type ?? 'button', disabled: isDisabled } : {};

    return (
      <Component
        ref={ref}
        aria-busy={isLoading}
        className={[
          'inline-flex items-center justify-center gap-2 rounded-xl font-medium',
          'transition-colors duration-150',
          isDisabled ? 'cursor-not-allowed' : '',
          VARIANTS[variant],
          SIZES[size],
          fullWidth ? 'w-full' : '',
          className,
        ].join(' ')}
        {...buttonProps}
        {...rest}
      >
        {isLoading ? (
          <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
        ) : LeftIcon ? (
          <LeftIcon className="h-4 w-4" aria-hidden="true" />
        ) : null}
        <span>{children}</span>
        {!isLoading && RightIcon && <RightIcon className="h-4 w-4" aria-hidden="true" />}
      </Component>
    );
  }
);

Button.displayName = 'Button';
export default Button;